import { render, staticRenderFns } from "./df-page-store-selection.vue?vue&type=template&id=0d422869"
import script from "./df-page-store-selection.ts?vue&type=script&lang=js&external"
export * from "./df-page-store-selection.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports